<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-eraser`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M30.577 4.586L45.72 19.728a2 2 0 010 2.828L27.825 40.451h8.66a1 1 0 011 1v1.999a1 1 0 01-1 1H23.214a1.99 1.99 0 01-.232.013l-9.698-.013a2 2 0 01-1.411-.586L1.586 33.577a2 2 0 010-2.828L27.749 4.586a2 2 0 012.828 0zM11.256 26.735l-5.428 5.428 8.288 8.288h8.041l1.429-1.427a1 1 0 01-.19-.15l-12.14-12.139zM29.163 8.828L14.084 23.906l12.14 12.14c.058.059.108.123.149.19l15.104-15.094L29.163 8.828z"/></svg>
</template>
<script>

export default {
  name: 'IconEraser',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
